import React, { useMemo, useState } from 'react'
import { Container, DropDownContainer, InputSearch, TitleModal, TitlePlaceHolder, TitleSelected } from './style'
import Button from '../../molecules/button'
import { useTranslation } from 'react-i18next'
import SelectableList from '../../molecules/SelectableList'
import { SelectableItemProps } from '../../atoms/SelectableItem'
import BottomSheet from '../BottomSheet'
import { Platform, ScrollView, TextInputProps, View } from 'react-native'
import { InputProps } from '../../molecules/input'
import { Colors } from '@ui/themes'

export interface DropProps {
  placeholder: string
  icon: React.ReactNode
  data: SelectableItemProps[]
  active: number
  buttonIcon?: React.ReactNode
  allowIconAndText?: boolean
  onPress?: (_: SelectableItemProps, __: number | undefined) => void
  selectedItem?: number
  inputProps?: InputProps
  variant?: 'outlined' | 'underlined'
  color?: keyof Colors
  buttonText?: string
  disabled?: boolean
  textColor?: keyof Colors
  activeColor?: string
}

const Drop: React.FC<DropProps> = ({
  placeholder,
  icon,
  data,
  active,
  disabled = false,
  buttonIcon,
  buttonText = 'Continuar',
  onPress,
  selectedItem,
  inputProps,
  allowIconAndText = false,
  variant = 'underlined',
  color = 'primary',
  textColor = 'grey',
  activeColor,
}) => {
  const [isModalVisible, setModalVisible] = useState(false)
  const toggleModal = () => {
    if (!disabled) {
      setModalVisible(!isModalVisible)
    }
  }
  const label = useMemo(() => {
    return data[active]?.title ?? placeholder
  }, [active, data, placeholder])

  const ActualTitle = useMemo(() => {
    return active === -1 ? TitlePlaceHolder : TitleSelected
  }, [active])

  return (
    <Container
      variant={variant}

    >
      <DropDownContainer onPress={toggleModal} disabled={disabled}>
        <ActualTitle type="small" fontWeight="400" textAlign="center" color={textColor as keyof Colors}>{label}</ActualTitle>
        <View
          style={{
            transform: isModalVisible ? [{ rotate: '90deg' }] : [{ rotate: '0deg' }],
          }}
        >
          {icon}
        </View>
      </DropDownContainer>
      <BottomSheet visible={isModalVisible} onHide={toggleModal}>
        <TitleModal type="H3" fontWeight="700" textAlign="center">{placeholder}</TitleModal>
        <ScrollView style={{ marginVertical: 20 }}>
          <SelectableList data={data} onPress={onPress} selectedItem={selectedItem} activeColor={activeColor} />
        </ScrollView>
        {inputProps && <InputSearch {...inputProps} />}
        <Button
          title={buttonText}
          size="block"
          textType="cta_medium"
          borderRadius={5}
          textColor={color == 'aena' ? "foreground0" : "background0"}
          color={color ?? "primary"}
          onPress={toggleModal}
          icon={buttonIcon}
          style={{ marginBottom: Platform.OS === 'ios' ? 20 : 0 }}
          allowIconAndText
        />
      </BottomSheet>
    </Container>
  )
}

export default Drop
